import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "flex-row-box chat-base"
};
const _hoisted_2 = {
  class: "list-wrap"
};
const _hoisted_3 = {
  class: "flex-row-box list-item radius-middle"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "table-wrap"
};
const _hoisted_6 = {
  key: 2,
  class: "official-base-info"
};
const _hoisted_7 = {
  class: "dialog-footer",
  style: {
    "display": "flex",
    "justify-content": "flex-end"
  }
};
import { ref, reactive, onMounted, nextTick } from 'vue';
import { getKnowledgeTypeList, getOfficialKnowledgeList, addUserKnowledge, getAppUserKnowledgePage, deleteUserKnowledge, updateUserKnowledgeName, getAppKnowledgeContentPage, getAppOfficialKnowledge, addKnowledgeContent, deleteKnowledgeContent } from '@/request/knowledge';
import { ElMessage, ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import { getToken } from '@/api';
import { chatBaseDriver, driverTypeStorage } from '@/utils/driver.ts';
export default /*@__PURE__*/_defineComponent({
  __name: 'chatbase',
  setup(__props) {
    const knowladgeList = ref([]);
    const baseApi = process.env.VUE_APP_API_BASE_URL;
    // 用户指引
    let {
      chatBaseDriverFn,
      driverType
    } = chatBaseDriver();
    const tableData = ref([]);
    const officialBaseInfo = ref({});
    let addKnowledgeBase = ref(null);
    const visible = ref(false);
    const addKnowledge = () => {
      visible.value = true;
    };
    const addForm = reactive({
      type: '1',
      officialId: '',
      typeId: '',
      name: ''
    });
    let rules = reactive({
      // 知识库类型必填
      type: [{
        required: true,
        message: '请选择知识库类型',
        trigger: 'change'
      }],
      // 知识库名称必填且长度限制
      name: [{
        required: true,
        message: '请输入知识库名称',
        trigger: 'blur'
      }, {
        min: 2,
        max: 15,
        message: '长度在 2 到 15 个字符',
        trigger: 'blur'
      }],
      // 自定义知识库类型ID必填（仅当 type 为 1 时）
      typeId: [{
        required: false,
        message: '请选择知识库类型',
        trigger: 'change'
      }],
      // 官方知识库ID必填（仅当 type 为 2 时）
      officialId: [{
        required: true,
        message: '请选择官方知识库',
        trigger: 'change'
      }]
    });
    const knowladgeTypeOptions = ref([]);
    const knowladgeOptions = ref([]);
    // 获取知识库类型
    const getKnowladgeType = async () => {
      const res = await getKnowledgeTypeList();
      console.warn(res);
      if (res.data.code === 200) {
        knowladgeTypeOptions.value = res.data.data;
      }
    };
    getKnowladgeType();
    const formatValue = (row, column, cellvalue) => {
      if (column.property == 'typeId') {
        const [d] = knowladgeTypeOptions.value.filter(item => item.id == cellvalue);
        return d ? d.name : '-';
      }
    };
    // 获取官方知识库列表
    const getOfficialKnowladge = async () => {
      const res = await getOfficialKnowledgeList();
      if (res.data.code === 200) {
        knowladgeOptions.value = res.data.data;
      }
    };
    getOfficialKnowladge();
    const submitLoading = ref(false);
    const onSubmit = refs => {
      refs.validate(valid => {
        if (valid) {
          submitLoading.value = true; // 开始加载状态
          const {
            typeId,
            officialId,
            name
          } = addForm;
          addUserKnowledge({
            typeId,
            officialId,
            name
          }).then(res => {
            if (res.data.code === 200) {
              ElMessage({
                message: '添加成功！',
                type: 'success'
              });
              visible.value = false;
              initAddForm(); // 清空表单
              getKnowladge(); // 获取知识库列表
            } else {
              ElMessage({
                message: '操作失败！',
                type: 'error'
              });
            }
          }).finally(() => {
            submitLoading.value = false; // 结束加载状态
          });
        } else {
          ElMessage({
            message: '表单验证失败，请检查您的输入！',
            type: 'warning'
          });
          return false;
        }
      });
    };
    const initAddForm = () => {
      addForm.type = '1';
      addForm.officialId = '';
      addForm.typeId = '';
      addForm.name = '';
    };
    // 获取用户知识库列表
    const activeBaseId = ref('');
    const activeBaseType = ref('');
    const activeBase = ref();
    const getKnowladge = () => {
      getAppUserKnowledgePage({
        pageIndex: 1,
        pageSize: 1000,
        keyword: ''
      }).then(res => {
        const {
          code,
          data
        } = res.data;
        knowladgeList.value = data.list || [];
        if (data.list[0]) {
          toggleBase(data.list[0]);
        }
      });
    };
    getKnowladge();
    const toggleBase = item => {
      activeBase.value = item;
      activeBaseId.value = item.id;
      activeBaseType.value = item.officialId ? 'official' : 'custom';
      getBaseDetail(item);
    };
    // 获取知识库内容详情
    const getBaseDetail = item => {
      if (item.officialId) {
        getAppOfficialKnowledge(item.officialId).then(res => {
          const {
            code,
            data
          } = res.data;
          officialBaseInfo.value = data;
        });
      } else {
        getAppKnowledgeContentPage({
          pageIndex: 1,
          pageSize: 100,
          knowledgeId: item.id
        }).then(res => {
          const {
            code,
            data
          } = res.data;
          tableData.value = data.list || [];
        });
      }
    };
    // 删除知识库
    const onDeleteKnowladge = id => {
      ElMessageBox.confirm('确认删除知识库?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delKnowladge(id);
      });
    };
    const delKnowladge = id => {
      deleteUserKnowledge(id).then(res => {
        if (res.data.code === 200) {
          getKnowladge();
          ElMessage({
            message: '删除成功',
            type: 'success'
          });
        } else {
          ElMessage({
            message: res.data.msg,
            type: 'error'
          });
        }
      });
    };
    // 重命名
    const handleBaseRename = (id, name) => {
      ElMessageBox.prompt('请输入知识库名称', '重命名', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        inputValue: name,
        inputValidator: value => {
          if (value.length > 25) {
            return '名称不能超过25个字';
          }
          return true;
        }
      }).then(({
        value
      }) => {
        updateUserKnowledgeName({
          id,
          name: value
        }).then(res => {
          ElMessage({
            message: res.data.msg,
            type: res.data.code === 200 ? 'success' : 'error'
          });
          getKnowladge();
        });
      });
    };
    // 知识库文件上传
    const fileList = ref([]);
    const uploader = ref();
    const headers = {
      Authorization: getToken()
    };
    const uploadLoading = ref(false);
    const handleUploadSuccess = response => {
      const {
        data
      } = response;
      const {
        originalFilename,
        url
      } = data;
      uploadLoading.value = false;
      addBaseContent(originalFilename, url);
    };
    const handleUploadError = response => {
      fileList.value = [];
      uploader.value.clearFiles();
    };
    let handleBeforeUpload = file => {
      const allowedTypes = ['text/plain', 'text/markdown', 'application/pdf', 'text/html', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/csv' // .csv
      ];
      const isAllowedType = allowedTypes.includes(file.type);
      const isLt15M = file.size / 1024 / 1024 < 15;
      if (!isAllowedType) {
        ElMessage.error('不支持该文件类型');
        return false;
      }
      if (!isLt15M) {
        ElMessage.error('文件大小不能超过 15MB');
        return false;
      }
      return true;
    };
    // 添加自定义知识库内容
    const addBaseContent = (fileName, fileUrl) => {
      addKnowledgeContent({
        typeId: activeBase.value.typeId,
        fileName,
        fileUrl,
        knowledgeId: activeBaseId.value,
        businessType: 2
      }).then(res => {
        const {
          code,
          data,
          msg
        } = res.data;
        ElMessage({
          message: msg,
          type: code == 200 ? 'success' : 'error'
        });
        getBaseDetail(activeBase.value);
      }).finally(() => {
        fileList.value = [];
        uploader.value.clearFiles();
      });
    };
    // 删除知识库自定义内容
    const handleFileDelete = id => {
      ElMessageBox.confirm('确认删除此条内容?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteKnowledgeContent(id).then(res => {
          const {
            code,
            data,
            msg
          } = res.data;
          ElMessage({
            message: msg,
            type: code == 200 ? 'success' : 'error'
          });
          getBaseDetail(activeBase.value);
        });
      });
    };
    const handleDownload = row => {
      window.open(row.fileUrl);
    };
    onMounted(() => {
      nextTick(() => {
        // 如果没显示过操作指导，则显示
        if (!driverTypeStorage.exists(driverType)) chatBaseDriverFn();
      });
    });
    return (_ctx, _cache) => {
      const _component_Plus = _resolveComponent("Plus");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_svgIcon = _resolveComponent("svgIcon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        style: {
          "width": "100%",
          "height": "50px"
        },
        plain: "",
        onClick: addKnowledge,
        id: "add-knowledge-btn"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Plus)]),
          _: 1
        }), _cache[6] || (_cache[6] = _createTextVNode("添加知识库"))]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(knowladgeList.value, item => {
        return _openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", {
          class: _normalizeClass(["list-item-name", activeBaseId.value == item.id && 'active-text-plain']),
          onClick: $event => toggleBase(item)
        }, _toDisplayString(item.name), 11, _hoisted_4), _createVNode(_component_el_dropdown, null, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
              onClick: $event => handleBaseRename(item.id, item.name)
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("重命名")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_dropdown_item, {
              onClick: $event => onDeleteKnowladge(item.id)
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("删除")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("span", {
            class: "el-dropdown-link"
          }, " ··· ", -1))]),
          _: 2
        }, 1024)]);
      }), 256))]), _createElementVNode("div", _hoisted_5, [activeBaseType.value == 'custom' ? (_openBlock(), _createBlock(_component_el_upload, {
        key: 0,
        "file-list": fileList.value,
        "onUpdate:fileList": _cache[0] || (_cache[0] = $event => fileList.value = $event),
        "show-file-list": false,
        ref_key: "uploader",
        ref: uploader,
        accept: ".txt,.md,.pdf,.html,.xls,.docx,.csv",
        headers: headers,
        action: `${_unref(baseApi)}/common/upload`,
        "on-success": handleUploadSuccess,
        "on-error": handleUploadError,
        "before-upload": _unref(handleBeforeUpload)
      }, {
        tip: _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("div", {
          class: "el-upload__tip"
        }, "TXT、 MARKDOWN、 PDF、 HTML、 XLS、 DOCX、 CSV，每个文件不超过 15MB。", -1)])),
        default: _withCtx(() => [_createVNode(_component_el_button, {
          round: "",
          type: "primary",
          loading: uploadLoading.value,
          id: "add-knowledge-upload"
        }, {
          default: _withCtx(() => [_createVNode(_component_svgIcon, {
            iconClass: "chat-new",
            style: {
              "margin-right": "6px"
            },
            width: "15px",
            height: "12px"
          }), _cache[10] || (_cache[10] = _createTextVNode("上传文件 "))]),
          _: 1
        }, 8, ["loading"])]),
        _: 1
      }, 8, ["file-list", "action", "before-upload"])) : _createCommentVNode("", true), activeBaseType.value == 'custom' ? (_openBlock(), _createBlock(_component_el_table, {
        key: 1,
        data: tableData.value,
        style: {
          "width": "100%",
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "index",
          label: "序号",
          width: "50"
        }), _createVNode(_component_el_table_column, {
          prop: "typeId",
          label: "知识库类型",
          width: "180",
          format: formatValue
        }), _createVNode(_component_el_table_column, {
          prop: "fileName",
          label: "文件名称"
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "address",
          label: "操作",
          width: "140"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "text",
            style: {
              "color": "red"
            },
            onClick: $event => handleFileDelete(scope.row.id)
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "text",
            onClick: $event => handleDownload(scope.row)
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("下载")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("p", null, "知识库名称：" + _toDisplayString(officialBaseInfo.value.name), 1), _createElementVNode("p", null, "知识库类型：" + _toDisplayString(formatValue({}, {
        property: 'typeId'
      }, officialBaseInfo.value.typeId)), 1)]))]), _createVNode(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => visible.value = $event),
        title: "新建知识库",
        width: "400",
        center: "",
        "show-close": false,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false),
          round: ""
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          round: "",
          loading: submitLoading.value,
          onClick: _cache[4] || (_cache[4] = $event => onSubmit(_unref(addKnowledgeBase)))
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("确定")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "auto",
          model: addForm,
          rules: _unref(rules),
          style: {
            "width": "100%",
            "margin-top": "10px"
          },
          ref_key: "addKnowledgeBase",
          ref: addKnowledgeBase
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "知识库类型",
            prop: "type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: addForm.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => addForm.type = $event),
              class: "ml-4"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: "1"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("自定义知识库")])),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: "2"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("官方互动库")])),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "知识库名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: addForm.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => addForm.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});